export const SUPPORTED_EMBED_HOSTS = {
  youtube: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/i,
  soundcloud: /(?:https?:\/\/)?(?:www\.)?soundcloud\.com\//i,
};

export const extractEmbedFromContent = (raw) => {
  if (!raw) return { content: '', embedUrl: null };
  const urlRegex = /(https?:\/\/[^\s]+)/gi;
  const urls = raw.match(urlRegex) || [];
  if (!urls.length) return { content: raw.trim(), embedUrl: null };

  const candidates = urls.filter((u) =>
    SUPPORTED_EMBED_HOSTS.youtube.test(u) || SUPPORTED_EMBED_HOSTS.soundcloud.test(u)
  );
  if (!candidates.length) return { content: raw.trim(), embedUrl: null };

  const embedUrl = candidates[0];
  const cleaned = raw.replace(embedUrl, '').replace(/\s+$/g, '').trim();
  return { content: cleaned, embedUrl };
};

export const getEmbedSrc = (url) => {
  if (!url) return null;
  const ytMatch = url.match(SUPPORTED_EMBED_HOSTS.youtube);
  if (ytMatch && ytMatch[1]) return `https://www.youtube-nocookie.com/embed/${ytMatch[1]}`;
  if (SUPPORTED_EMBED_HOSTS.soundcloud.test(url)) {
    return `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}`;
  }
  return url;
};
